import { useCustomersServiceObjectShowQuery } from "@/services/backend/customers/api/service-object-api";
import { AddressToLine } from "@/services/backend/addresses/components/address-to-line";

export function ServiceObjectAddress({ id }: { id?: string }) {
  const { data } = useCustomersServiceObjectShowQuery({ id: id ?? "" });

  if (!data) {
    return "";
  }

  return <AddressToLine address={data.address} />;
}
